module.exports = __webpack_public_path__ + "static/media/03.56096a8a.jpg";